import moment from "moment";
import { saveState, loadState } from "./localStorage";

const actions = {
  SET_STATE: 'publishedScheduleSlice/SET_STATE',
  SET_GROUPS: 'publishedScheduleSlice/SET_GROUPS',
  SET_RESOURCES: 'publishedScheduleSlice/SET_RESOURCES',
  SET_PILOTS: 'publishedScheduleSlice/SET_PILOTS',
  SET_PILOT_CERTIFICATIONS: 'publishedScheduleSlice/SET_PILOT_CERTIFICATIONS',
  SET_MAINTENANCE: 'publishedScheduleSlice/SET_MAINTENANCE',
  SET_MAINTENANCE_CERTIFICATIONS: 'publishedScheduleSlice/SET_MAINTENANCE_CERTIFICATIONS',
  SET_SELECTED_DATE: 'publishedScheduleSlice/SET_SELECTED_DATE',
  SET_SORT_ORDER: 'publishedScheduleSlice/SET_SORT_ORDER',
  CLEAR_STATE: 'publishedScheduleSlice/CLEAR_STATE',
};

const preloadedState = loadState();

const initialState = {
  groups: ['Resources', 'Pilots', 'Maintenance'],
  resources: [],
  pilots: [],
  pilotCertifications: [],
  maintenance: [],
  maintenanceCertifications: [],
  selectedDate: moment(),
  sortOrder: 'asc',
};

const clearAndResetState = () => {
    localStorage.clear();
    return initialState;
}

export default function reducer(state = preloadedState || initialState, action) {
  let newState = state;
  switch (action.type) {
    case actions.CLEAR_STATE:
      return clearAndResetState();
    case actions.SET_STATE:
      newState = { ...state, ...action.payload };
      saveState(newState);
      return newState;
    case actions.SET_GROUPS:
      newState = { ...state,
        'groups': action.payload ,
      };
      saveState(newState);
      return newState;
    case actions.SET_RESOURCES:
      newState = { ...state,
        'resources': action.payload ,
      };
      saveState(newState);
      return newState;
    case actions.SET_PILOTS:
      newState = { ...state,
        'pilots': action.payload ,
      };
      saveState(newState);
      return newState;
    case actions.SET_PILOT_CERTIFICATIONS:
      newState = { ...state,
        'pilotCertifications': action.payload ,
      };
      saveState(newState);
      return newState;
    case actions.SET_MAINTENANCE:
      newState = { ...state,
        'maintenance': action.payload ,
      };
      saveState(newState);
      return newState;
    case actions.SET_MAINTENANCE_CERTIFICATIONS:
      newState = { ...state,
        'maintenanceCertifications': action.payload ,
      };
      saveState(newState);
      return newState;
    case actions.SET_SELECTED_DATE:
      newState = { ...state,
        'selectedDate': action.payload ,
      };
      saveState(newState);
      return newState;
    case actions.SET_SORT_ORDER:
      newState = { ...state,
        'sortOrder': action.payload ,
      };
      saveState(newState);
      return newState;
    default:
      saveState(state);
      return state;
  }
}

export const selectGroups = state => state.publishedScheduleSlice.groups
export const selectResources = state => state.publishedScheduleSlice.resources
export const selectPilots = state => state.publishedScheduleSlice.pilots
export const selectPilotCertifications = state => state.publishedScheduleSlice.pilotCertifications
export const selectMaintenance = state => state.publishedScheduleSlice.maintenance
export const selectMaintenanceCertifications = state => state.publishedScheduleSlice.maintenanceCertifications
export const selectSelectedDate = state => state.publishedScheduleSlice.selectedDate
export const selectSortOrder = state => state.publishedScheduleSlice.sortOrder

